import { backendUrl, spacesBucketUrl } from "../Constants"


export const BASE_URL = backendUrl
export const IMAGE_URL = spacesBucketUrl
export const API_URL = BASE_URL + 'api/'

export const EMPLOYEES_API = API_URL + 'employees/'
export const DESIGNATIONS_API = API_URL + 'designations/'
export const EMPLOYEE_DESIGNATIONS_API = API_URL + 'employeeDesignations/'

export const DIVISIONS_API = API_URL + 'divisions/'
export const DISTRICTS_API = API_URL + 'districts/'
export const AREAS_API = API_URL + 'areas/'

export const APP_SETTINGS_API = API_URL + 'appSettings/'
export const SLIDERS_API = API_URL + 'sliders/'

export const PRICINGS = API_URL + 'pricings/'
export const TOOLS = API_URL + 'tools/'

export const DATA_TYPES = API_URL + 'datatypes/'
export const SERVICES = API_URL + 'services/'
export const SERVICE_DATA_TYPES = API_URL + 'servicedatatypes/'
export const OPERATIONS = API_URL + 'operations/'

export const SOLUTION_USES = API_URL + 'solutionuses/'
export const INDUSTRIES = API_URL + 'industries/'

export const CASE_STUDIES = API_URL + 'casestudies/'

export const BLOGS_API = API_URL + 'blogs/'
export const SUBCRIPTIONS = API_URL + 'subscriptions/'

export const TESTIMONIALS = API_URL + 'testimonials/'

export const QUOTES = API_URL + 'quotes/'
export const CONTACTS = API_URL + 'contacts/'

export const TEAMS_API = API_URL + 'teams/'

